module.exports = __webpack_public_path__ + "images/category_lp/art_work/assessment_achievements/5_924406f9b88586db0b1e71037ba7d25b.jpg";